import { WithChildren } from '@/types/component';

const PullQuote = ({ children }: WithChildren) => (
  <blockquote
    data-testid='pullQuote'
    className='relative flex justify-center rounded border border-grey-l3 p-6'
  >
    <div className='flex justify-center absolute pt-1.5 bg-white text-marketing-navy w-8 h-8 rounded-full text-4xl top-[-16px] left-[calc(50%-20px)] border border-marketing-navy shadow-white'>
      &#8220;
    </div>
    <div className='text-marketing-navy italic text-center'>{children}</div>
  </blockquote>
);

export default PullQuote;
